/* Every frame offers text OR a date. Larger frames have two lines in text mode. */
(() => {
  let smallFrame = false;
  let boundForm;
  const find = selector => document.querySelector(selector);
  const isDateMode = () => find('[name="frame_customization_mode"]:checked')?.value === 'date';

  // Format the calendar value directly, without timezone conversion.
  // Use unpadded month/day and a two-digit year (M.D.YY).
  function formatDate(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    if (!match || Number(match[1]) < 1) return '';
    const [, year, month, day] = match;
    const calendar = new Date(0);
    calendar.setUTCFullYear(Number(year), Number(month) - 1, Number(day));
    if (calendar.getUTCFullYear() !== Number(year) || calendar.getUTCMonth() !== Number(month) - 1 || calendar.getUTCDate() !== Number(day)) return '';
    return `${Number(month)}.${Number(day)}.${year.slice(-2)}`;
  }

  function isValidDate() {
    const input = find('.js-frame-date');
    return !!input && input.validity.valid && !!formatDate(input.value);
  }

  function lineOneText() {
    return isDateMode() ? formatDate(find('.js-frame-date')?.value) : find('.js-embroidery-text-line-1')?.value || '';
  }

  function renderPreview() {
    const preview = find('.js-embroidery-text-preview-line-1');
    const input = find('.js-embroidery-text-line-1');
    if (!preview || !input) return;
    const text = lineOneText();
    preview.textContent = text;
    find('.js-embroidery-text-preview-line-2').textContent = isDateMode() ? '' : find('.js-embroidery-text-line-2').value;
    if (isDateMode()) {
      preview.style.fontSize = window.innerWidth < 1024 ? '32px' : '52px';
    } else if (input.maxLength <= 3) {
      preview.style.fontSize = `${window.innerWidth < 1024 ? 100 - text.length * 5 : 250 - text.length * 30}px`;
    } else {
      preview.style.fontSize = '52px';
    }
  }

  function applyMode() {
    const dateMode = isDateMode();
    const initials = find('.js-embroidery-text-line-1');
    const date = find('.js-frame-date');
    find('.js-frame-initials-field').hidden = dateMode;
    find('.js-frame-date-field').hidden = !dateMode;
    initials.required = !dateMode;
    initials.disabled = dateMode;
    const second = find('.js-embroidery-text-line-2');
    second.disabled = dateMode || second.maxLength === 0;
    second.style.display = second.disabled ? 'none' : 'block';
    find('.js-embroidery-text-line-2-label').style.display = second.style.display;
    find('.js-embroidery-text-error-line-2').style.display = 'none';
    date.required = dateMode;
    date.disabled = !dateMode;
    find('.js-frame-date-error').hidden = true;
    find('.js-embroidery-text-error').style.display = 'none';
    const warning = find('#embroidery-form .js-character-count-warning');
    warning.style.display = !dateMode && !smallFrame && warning.textContent.trim() ? 'block' : 'none';
    renderPreview();
    window.enableSubmitButton?.();
  }

  function configure(isSmall) {
    const form = find('#embroidery-form');
    if (!form || !find('.js-frame-date')) return;
    smallFrame = form.dataset.customizationGeneric === 'true' ? false : isSmall;
    const dateEnabled = form.dataset.customizationGeneric !== 'true' || form.dataset.dateEnabled === 'true';
    find('.js-frame-customization-mode').hidden = !dateEnabled;
    if (!dateEnabled) find('[name="frame_customization_mode"][value="initials"]').checked = true;
    find('.js-frame-text-mode-label').textContent = 'Text';
    const label = find('.js-frame-initials-field label');
    label.firstChild.textContent = smallFrame ? 'Custom text ' : 'Customize Text Line 1 ';
    find('.js-frame-text-limit').hidden = !smallFrame;
    find('.js-frame-text-limit').textContent = `Up to ${find('.js-embroidery-text-line-1').maxLength} characters`;
    find('.js-frame-date-format').textContent = 'Embroidered as M.D.YY (for example, 1.1.26).';
    if (boundForm !== form) {
      boundForm = form;
      form.querySelectorAll('[name="frame_customization_mode"]').forEach(input => input.addEventListener('change', applyMode));
      const updateDate = () => { renderPreview(); window.displayTextValid?.(); window.enableSubmitButton?.(); };
      find('.js-frame-date').addEventListener('input', updateDate);
      find('.js-frame-date').addEventListener('change', updateDate);
    }
    applyMode();
  }

  function saveSummary(formId) {
    const input = find('.js-property-frame-type');
    if (!input) return;
    input.value = isDateMode() ? 'Date' : 'Text';
    input.closest('.js-frame-type-summary').hidden = false;
    input.setAttribute('form', formId);
  }

  function clearSummary() {
    const input = find('.js-property-frame-type');
    if (!input) return;
    input.value = '';
    input.removeAttribute('form');
    input.closest('.js-frame-type-summary').hidden = true;
  }

  function reset() {
    const date = find('.js-frame-date');
    if (!date) return;
    date.value = '';
    find('[name="frame_customization_mode"][value="initials"]').checked = true;
    clearSummary();
    applyMode();
  }

  window.frameCustomization = { configure, isDateMode, isValidDate, formatDate, lineOneText, renderPreview, saveSummary, clearSummary, reset };
})();
